import { __decorate } from "tslib";
import colors from '@/styles/color.scss';
import lang from '@blade-sxp/portrait-management/lang/index';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { LibStatusEnum, PageOrderEnum, PageQueryTypeEnum } from '@blade-sxp/portrait-management/interfaces/common';
import { enableVehicleLib, disableVehicleLib, deleteVehicleLib } from '@blade-sxp/portrait-management/api/vehicleLib';
import { Scale } from '@blade/common/utils/auto-scale';
import AuthNewitem from '@blade/common/components/auth/auth-newItem.vue';
import { permissionlevel } from '@blade/common/constants/role-mode';
import { SYSTEMCODE } from '@blade/common/constants/code';
const Webapi = {
    enableVehicleLib,
    disableVehicleLib,
    deleteVehicleLib,
};
let default_1 = class default_1 extends Vue {
    // 表格数据
    data;
    // 加载中
    loading;
    // 分页参数
    pagination;
    // 页面刷新
    refresh;
    // 重新拉下内容
    reload;
    showBtns;
    // 权限级别
    permissionlevel = permissionlevel;
    systemCode = SYSTEMCODE;
    // 漏斗图标
    funnelIcon = require('@blade-sxp/task-management/assets/union.png');
    // 默认排序
    defaultSort = { prop: 'updateAt', order: 'descending' };
    // 表格最小宽度
    defaultTableMinWidth = {
        libraryName: 268 * Scale,
        currentSize: 140 * Scale,
        status: 140 * Scale,
        createBy: 200 * Scale,
        updateAt: 200 * Scale,
        operate: 172 * Scale,
    };
    defaultPageSize = [10, 20, 50, 100, 200];
    filterLibraryStatus = [];
    cellBackground = colors.colorBoxBg;
    // 提交中
    submiting = false;
    initI18n() {
        this.filterLibraryStatus = [
            { text: String(this.$t('enable')), value: LibStatusEnum.ENABLE },
            { text: String(this.$t('disabled')), value: LibStatusEnum.DISABLE },
        ];
    }
    handleSizeChange(val) {
        this.pagination.size = val;
        this.$emit('update:pagination', this.pagination);
    }
    handleCurrentChange(val) {
        this.pagination.page = val;
        this.$emit('update:pagination', this.pagination);
    }
    vehicleNumberFormatter(e) {
        return String(e.currentSize).replace(/\d{1,3}(?=(\d{3})+$)/g, '$&,');
    }
    filterChange(e) {
        if (e.status && e.status instanceof Array && e.status.length > 0)
            this.pagination.status = e.status[0];
        else
            this.pagination.status = undefined;
        this.$emit('update:pagination', this.pagination);
        this.refresh();
    }
    sortChange(order) {
        this.pagination.pageOrderList = [
            {
                orderField: 'updateAt',
                orderType: order.order === 'ascending' ? PageOrderEnum.ASC : PageOrderEnum.DESC,
            },
        ];
        this.$emit('update:pagination', this.pagination);
        this.refresh();
    }
    cellClick(row, column) {
        if (column.property === 'name') {
            this.$refs[`popover-` + row.libId].doClose();
        }
    }
    /**
     * @description 获取行李库状态点颜色
     */
    getLibraryStatusDotColor(status) {
        return status === LibStatusEnum.ENABLE ? colors.lineFillStyle : colors['gray-text-7'];
    }
    /**
     * @description 获取行李库状态点颜色
     */
    getLibraryStatusName(status) {
        return status === LibStatusEnum.ENABLE ? this.$t('enable') : this.$t('disabled');
    }
    goDetail(item) {
        this.$router.push({ name: 'vehicleList', query: { libId: item.libId.toString(), type: PageQueryTypeEnum.DETAIL, libName: item.name } });
    }
    isAllowDisable(status) {
        return status === LibStatusEnum.ENABLE;
    }
    handleEdit(item) {
        this.$emit('edit', item);
    }
    /**
     * @description 禁用操作
     */
    async handleDisable(item) {
        if (this.submiting)
            return;
        this.submiting = true;
        try {
            await Webapi.disableVehicleLib(item.libId);
            this.$message({
                customClass: 'success-message',
                message: this.$t('disabledSuccessfully'),
                type: 'success',
                showClose: true,
            });
            this.reload();
        }
        catch (error) {
            console.log('handleEnable Err', error);
        }
        this.submiting = false;
    }
    /**
     * @description 启用操作
     */
    async handleEnable(item) {
        if (this.submiting)
            return;
        this.submiting = true;
        try {
            await Webapi.enableVehicleLib(item.libId);
            this.$message({
                customClass: 'success-message',
                message: this.$t('enabledSuccessfully'),
                type: 'success',
                showClose: true,
            });
            this.reload();
        }
        catch (error) {
            console.log('handleEnable Err', error);
        }
        this.submiting = false;
    }
    /**
     * @description: 删除
     */
    handleDelete(item) {
        this.$elconfirm(`${this.$t('deleteVehicleLibTip')}`, `${this.$t('tip')}`, {
            type: 'warning',
            cancelButtonText: `${this.$t('common.cancel')}`,
            confirmButtonText: ` ${this.$t('common.confirm')}`,
            cancelButtonClass: 'cancel-roi-tip',
            confirmButtonClass: 'confirm-roi-tip',
            callback: (action) => {
                if (action === 'confirm') {
                    this.deleteVehicleLib(item);
                }
            },
        });
    }
    async deleteVehicleLib(item) {
        try {
            await Webapi.deleteVehicleLib(item.libId);
            this.$message({
                customClass: 'success-message',
                message: this.$t('deletedSuccessfully'),
                type: 'success',
                showClose: true,
            });
            this.handleCurrentChange(1);
            this.refresh();
        }
        catch (error) {
            console.log('deleteVehicleLib error', error);
        }
    }
    mounted() {
        this.initI18n();
    }
};
__decorate([
    Prop()
], default_1.prototype, "data", void 0);
__decorate([
    Prop()
], default_1.prototype, "loading", void 0);
__decorate([
    Prop()
], default_1.prototype, "pagination", void 0);
__decorate([
    Prop()
], default_1.prototype, "refresh", void 0);
__decorate([
    Prop()
], default_1.prototype, "reload", void 0);
__decorate([
    Prop({ default: true, type: Boolean })
], default_1.prototype, "showBtns", void 0);
__decorate([
    Watch('$i18n.locale')
], default_1.prototype, "initI18n", null);
default_1 = __decorate([
    Component({
        components: {
            AuthNewitem,
        },
        i18n: { messages: lang },
    })
], default_1);
export default default_1;
